import type { ComponentType } from 'react';

export type MangoElementProps = Record<string, unknown>;

export const asMangoElement = (component: unknown): ComponentType<MangoElementProps> => {
  return component as ComponentType<MangoElementProps>;
};
